import React, { useMemo } from 'react';
import { Form, Input, InputNumber, Select, DatePicker } from 'antd';
import store from '../../store';
import dayjs from 'dayjs';

const EditableCell = ({
                        editing,
                        dataIndex,
                        title,
                        inputType,
                        record,
                        children,
                        form,
                        ...restProps
                      }) => {
  const inputNode = useMemo(() => {
    switch (inputType) {
      case 'number':
        return <InputNumber style={{ width: '100%' }} />;
      case 'date':
        return (
          <DatePicker
            showTime
            format="DD.MM.YYYY HH:mm"
            style={{ width: '100%' }}
          />
        );
      default:
        return <Input />;
    }
  }, [inputType]);

  const user = store.getState().auth.user;

  if (!editing) {
    return <td {...restProps}>{children}</td>;
  }

  // build up the Form.Item props
  const formItemProps = {
    name: dataIndex,
    style: { margin: 0 },
    rules: [
      {
        required: true,
        message: `Bitte ${title} eingeben!`,
      },
    ],
  };

  // date‐picker needs to translate between ISO string and dayjs
  if (inputType === 'date') {
    // for all dates, ensure the picker shows existing value
    formItemProps.getValueProps = (value) => ({
      value: value && !dayjs.isDayjs(value) ? dayjs(value) : value || null,
    });
    formItemProps.getValueFromEvent = (date) =>
      date ? date.toISOString() : null;

    // but for endTime we also want a cross‐field validator
    if (dataIndex === 'endTime') {
      formItemProps.rules.push({
        validator: (_, endValue) => {
          // get the current startTime from the form
          const startValue = form.getFieldValue('startTime');
          // if either is missing, skip validation
          if (!endValue || !startValue) {
            return Promise.resolve();
          }
          // compare as dayjs
          if (dayjs(endValue).isBefore(dayjs(startValue))) {
            return Promise.reject(
              new Error('Ende muss nach Start liegen!')
            );
          }
          return Promise.resolve();
        },
      });
    }
  }

  return (
    <td {...restProps}>
      <Form.Item {...formItemProps}>
        {dataIndex === 'role' ? (
          <Select>
            <Select.Option value="user">User</Select.Option>
            <Select.Option value="event_manager">Event Manager</Select.Option>
            {user?.role === 'admin' && (
              <Select.Option value="admin">Admin</Select.Option>
            )}
          </Select>
        ) : (
          inputNode
        )}
      </Form.Item>
    </td>
  );
};

export default React.memo(EditableCell);
